import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess240001ProDruckVglStatus: 'idle',
    startProcess240001ProDruckVglError: undefined as any,
    loadUserParamsProcess240001ProDruckVglStatus: 'idle',
    loadUserParamsProcess240001ProDruckVglError: undefined as any,

    process240001ProDruckVglList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess240001ProDruckVgl = createAsyncThunk('process240001ProDruckVglSlice/startProcess240001ProDruckVgl', async ({ process240001ProDruckVgl }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess240001ProDruckVgl/`,
        prepareData(process240001ProDruckVgl),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess240001ProDruckVglStatus } = getState().process240001ProDruckVglSlice
        return startProcess240001ProDruckVglStatus !== 'pending'
    }
})

export const loadUserParamsProcess240001ProDruckVgl = createAsyncThunk('process240001ProDruckVglSlice/loadUserParamsProcess240001ProDruckVgl', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess240001ProDruckVgl/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess240001ProDruckVglStatus } = getState().process240001ProDruckVglSlice
        return loadUserParamsProcess240001ProDruckVglStatus !== 'pending'
    }
})

const Process240001ProDruckVglSlice = createSlice({
    name: 'process240001ProDruckVglSlice',
    initialState,
    reducers: {
        resetstartProcess240001ProDruckVgl: (state) => {
            state.job = undefined
            state.startProcess240001ProDruckVglError = undefined
        },
        resetstartProcess240001ProDruckVglError: (state) => {
            state.startProcess240001ProDruckVglError = undefined
        },
        resetloadUserParamsProcess240001ProDruckVgl: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess240001ProDruckVglError = undefined
        },
        resetloadUserParamsProcess240001ProDruckVglError: (state) => {
            state.loadUserParamsProcess240001ProDruckVglError = undefined
        },
        removeFromProcess240001ProDruckVglListById: (state, action) => {
            state.process240001ProDruckVglList = state.process240001ProDruckVglList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess240001ProDruckVglListByIds: (state, action) => {
            state.process240001ProDruckVglList = state.process240001ProDruckVglList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process240001ProDruckVglList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess240001ProDruckVglStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process240001ProDruckVglList = []
            state.startProcess240001ProDruckVglStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess240001ProDruckVgl.pending, (state) => {
            state.startProcess240001ProDruckVglStatus = 'pending'
            state.startProcess240001ProDruckVglError = undefined
        })
        builder.addCase(startProcess240001ProDruckVgl.fulfilled, (state, action) => {
            state.startProcess240001ProDruckVglStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess240001ProDruckVgl.rejected, (state, action) => {
            state.startProcess240001ProDruckVglStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess240001ProDruckVglError = action.error.message
            } else {
                state.startProcess240001ProDruckVglError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess240001ProDruckVgl.pending, (state) => {
            state.loadUserParamsProcess240001ProDruckVglStatus = 'pending'
            state.loadUserParamsProcess240001ProDruckVglError = undefined
        })
        builder.addCase(loadUserParamsProcess240001ProDruckVgl.fulfilled, (state, action) => {
            state.loadUserParamsProcess240001ProDruckVglStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess240001ProDruckVgl.rejected, (state, action) => {
            state.loadUserParamsProcess240001ProDruckVglStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess240001ProDruckVglError = action.error.message
            } else {
                state.loadUserParamsProcess240001ProDruckVglError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess240001ProDruckVgl,
    resetstartProcess240001ProDruckVglError,
    resetloadUserParamsProcess240001ProDruckVgl,
    resetloadUserParamsProcess240001ProDruckVglError,
    removeFromProcess240001ProDruckVglListById,
    removeFromProcess240001ProDruckVglListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process240001ProDruckVglSlice.actions
export default Process240001ProDruckVglSlice.reducer
